import { authHttp, http } from '../http'
import * as routes from '../../routes/picking.routes'
import {
  urlGerarComparativoPicking,
  urlGetInfoParaArquivoTransferenciaProntaEntrega,
  urlOpenFormularioReconferencia,
  urlOpenResumoSeparacaoAnalitico,
  urlOpenComparativoPickingLoteValidade,
} from '../../routes/picking.routes'
import { errorHandler } from '../../../util/error.service'
import { openDownloadedFile, parseBlobToString } from '../../../util/download.service'

export async function savePicking({
  id,
  name,
  style,
  status,
  company_id,
  tp_id,
  type,
  referencia,
  observacao,
}) {
  try {
    let response
    if (id) {
      response = await authHttp().put(routes.urlPostPutPicking, {
        id,
        name,
        style,
        status,
        company_id,
        tp_id,
        type,
        referencia,
        observacao,
      })
    } else {
      response = await authHttp().post(routes.urlPostPutPicking, {
        name,
        style,
        status,
        company_id,
        tp_id,
        type,
        referencia,
        observacao,
      })
    }
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getPickings(
  tp_id,
  style,
  picking_status = 'all',
  periodoInicial,
  periodoFinal,
) {
  try {
    const response = await authHttp().get(
      routes.urlGetPickings(tp_id, picking_status, style, periodoInicial, periodoFinal),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getDeliveriesForPickings(picking_id, periodoInicial, periodoFinal, statusIds) {
  try {
    const response = await authHttp().get(
      routes.urlGetDeliveriesForPickings(picking_id, periodoInicial, periodoFinal, statusIds),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getDeliveriesProductsForPickings(picking_id) {
  try {
    const response = await authHttp().get(routes.urlGetDeliveriesProductsForPickings(picking_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function associateDeliveryToPicking(deliveries_ids, picking_id) {
  try {
    const response = await authHttp().post(
      routes.urlPostDeliveriesAssocPickings(picking_id),
      deliveries_ids,
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getDeliveriesForAreaAndTeamAssociation(picking_id) {
  try {
    const response = await authHttp().get(routes.urlGetAssocDeliveryAreaTeam(picking_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getAreaAndTeamAssociation(picking_id) {
  try {
    const response = await authHttp().get(routes.urlGetAssocAreaTeam(picking_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function associateDeliveryToAreas(info, isReconferencia = false, picking_id = null) {
  // info: [ {delivery_step_id, area_id}, ...]
  try {
    const url = isReconferencia
      ? routes.urlPostAssocDeliveryAreaReconferencia
      : routes.urlPostAssocDeliveryArea

    const body = isReconferencia && picking_id ? { picking_id, areas: info } : info

    const response = await authHttp().post(url, body)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function associateDeliveryToTeam(areas_ids, picking_id, pickingteam_id) {
  try {
    const response = await authHttp().post(
      routes.urlPostAssocAreaEquipe(picking_id, pickingteam_id),
      areas_ids,
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function updateAnyCheckersArea(picking_id, pickingarea_id, any_checkers) {
  try {
    const response = await authHttp().put(
      routes.urlPutAnyCheckersArea(picking_id, pickingarea_id),
      { any_checkers },
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function updateAnyCheckersPicking(picking_id, any_checkers) {
  try {
    const response = await authHttp().put(routes.urlPutAnyCheckersPicking(picking_id), {
      any_checkers,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function alterarStatusParaProntoParaDownload(picking_id) {
  try {
    const response = await authHttp().put(
      routes.urlPostAterarStatusParaProntoParaDownload(picking_id),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function apagarPicking(picking_id) {
  try {
    const response = await authHttp().delete(routes.urlDeletePicking(picking_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getInfoParaArquivoTransferenciaProntaEntrega(picking_id) {
  try {
    const response = await authHttp().get(
      urlGetInfoParaArquivoTransferenciaProntaEntrega(picking_id),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getHistoricoDeLeitura(picking_id) {
  try {
    const response = await authHttp().get(routes.urlGetHistoricoDeLeitura(picking_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getDeliveriesAssociadasBip(picking_id, product_code, area_nome) {
  try {
    const response = await authHttp().get(
      routes.urlGetDeliveriesAssociadasBip(picking_id, product_code, area_nome),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function putFinalizarAreaSeparacao(body) {
  try {
    const response = await authHttp().put(routes.urlFinalizarAreaSeparacao(), body)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function associarAreasDeSeparacaoPorRota(picking_id) {
  try {
    const response = await authHttp().get(
      routes.urlAssociarAreaDeSeparacaoPorRotaDeEntrega(picking_id),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function associarAreasDeSeparacaoPorRotaPorCidade(picking_id) {
  try {
    const response = await authHttp().get(
      routes.urlAssociarAreaDeSeparacaoPorRotaDeEntregaPorCidade(picking_id),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function associarUmClientePorAreaComPlacaPrevista(picking_id) {
  try {
    const response = await authHttp().get(
      routes.urlAssociarUmClientePorAreaComPlacaPrevista(picking_id),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function associarClientesAhRotaDeEntrega(associacoes) {
  try {
    const response = await authHttp().post(routes.urlAssociarClientesAhRotaDeEntrega(), associacoes)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function exportarPicking(picking_id) {
  try {
    const response = await authHttp().get(routes.urlGetExportarPicking(picking_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getCargasPendentesParaPicking(tp_id) {
  try {
    const response = await authHttp().get(routes.urlGetCargaPendenteParaPicking(tp_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getDeliveriesByCicloForPicking(tp_id, cycle_id, step) {
  try {
    const response = await authHttp().get(
      routes.urlGetDeliveriesByCicloForPicking(tp_id, cycle_id, step),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export function openFormularioReconferencia(picking) {
  try {
    const url = urlOpenFormularioReconferencia(picking.id)
    window.open(url, '_blank')
  } catch (error) {
    throw errorHandler(error)
  }
}

export function openResumoSeparacaoAnalitico(picking) {
  try {
    const url = urlOpenResumoSeparacaoAnalitico(picking.id)
    window.open(url, '_blank')
  } catch (error) {
    throw errorHandler(error)
  }
}

export function openResumoSeparacaoPorOrigemPDF(picking) {
  try {
    const url = routes.urlOpenResumoSeparacaoPorOrigemPDF(picking.id)
    window.open(url, '_blank')
  } catch (error) {
    throw errorHandler(error)
  }
}

export function openResumoSeparacaoPorOrigemEXCEL(picking) {
  try {
    const url = routes.urlOpenResumoSeparacaoPorOrigemEXCEL(picking.id)
    window.open(url, '_blank')
  } catch (error) {
    throw errorHandler(error)
  }
}

export function openListagemDeProdutosConferidosPDF(picking) {
  try {
    const url = routes.urlOpenListagemDeProdutosConferidosPDF(picking.id)
    window.open(url, '_blank')
  } catch (error) {
    throw errorHandler(error)
  }
}

export function openRelacaoPosicoesEstoquePalletArea(picking) {
  try {
    const url = routes.urlOpenRelacaoPosicoesEstoquePalletArea(picking.id)
    window.open(url, '_blank')
  } catch (error) {
    throw errorHandler(error)
  }
}

export function openFichaRecebimentoCarga(picking) {
  try {
    const url = routes.urlOpenFichaRecebimentoCarga(picking.id)
    window.open(url, '_blank')
  } catch (error) {
    throw errorHandler(error)
  }
}

export function openComparativoPickingLoteValidade(picking) {
  try {
    const url = urlOpenComparativoPickingLoteValidade(picking.id)
    window.open(url, '_blank')
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function gerarComparativoDoPicking(pickingId, comparativoType, fileContent) {
  try {
    const response = await http({
      url: urlGerarComparativoPicking(pickingId, comparativoType),
      method: 'POST',
      data: fileContent,
      responseType: 'blob',
    })
    openDownloadedFile(response.data)
  } catch (error) {
    throw errorHandler(await parseBlobToString(error.response.data))
  }
}

export async function gerarComparativoDoPickingEmExcel(pickingId, comparativoType, fileContent) {
  try {
    const response = await http({
      url: routes.urlGerarComparativoPickingExcel(pickingId, comparativoType),
      method: 'POST',
      data: fileContent,
      responseType: 'blob',
    })
    openDownloadedFile(response.data)
  } catch (error) {
    throw errorHandler(await parseBlobToString(error.response.data))
  }
}

export async function gerarPickingAhPartirRoteirizacao(info) {
  try {
    const response = await authHttp().post(routes.urlGerarPickingAhPartirRoteirizacao(), info)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function gerarPickingAhPartirRoteirizacaoClienteEstoque(info) {
  try {
    const response = await authHttp().post(
      routes.urlGerarPickingAhPartirRoteirizacaoClienteEstoque(),
      info,
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function gerarPickingReconferenciaAhPartirRoteirizacao(info) {
  try {
    const response = await authHttp().post(
      routes.urlGerarPickingReconferenciaAhPartirRoteirizacao(),
      info,
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function previewNomePickingAhPartirRoteirizacao(fleet_ids, estilo) {
  try {
    const response = await authHttp().post(routes.urlPreviewNomePickingAhPartirRoteirizacao(), {
      fleet_ids,
      estilo,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getPickingsByNF(tp_id, nf, pInicial, pFinal, company, style) {
  try {
    const response = await authHttp().get(
      routes.urlGetPickingsByNF(tp_id, nf, pInicial, pFinal, company, style),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getHistoricoLeituraPeriodoLote(tp_id, pInicial, pFinal, company_id) {
  try {
    const response = await authHttp().get(
      routes.urlGetHistoricoLeituraPeriodoLote(tp_id, company_id, pInicial, pFinal),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getPickingById(pickingId) {
  try {
    const response = await authHttp().get(routes.urlGetPickingById(pickingId))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// -------------------------
// Funções específicas para Reconferência
// -------------------------

export async function getPickingsReconferencia(
  tp_id,
  picking_status = 'all',
  periodoInicial,
  periodoFinal,
) {
  try {
    const response = await authHttp().get(
      routes.urlGetPickingsReconferencia(tp_id, picking_status, periodoInicial, periodoFinal),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function savePickingReconferencia({
  id,
  name,
  status,
  company_id,
  tp_id,
  type,
  referencia,
  observacao,
}) {
  try {
    let response
    if (id) {
      response = await authHttp().put(routes.urlPostPutPickingReconferencia, {
        id,
        name,
        style: 'Reconferencia',
        status,
        company_id,
        tp_id,
        type,
        referencia: referencia ? referencia.trim() : null,
        observacao: observacao ? observacao.trim() : null,
      })
    } else {
      response = await authHttp().post(routes.urlPostPutPickingReconferencia, {
        name,
        style: 'Reconferencia',
        status,
        company_id,
        tp_id,
        type,
        referencia: referencia ? referencia.trim() : null,
        observacao: observacao ? observacao.trim() : null,
      })
    }
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// -------------------------
// Re-conferência Etiqueta (Pallet Area)
// -------------------------

export async function getReconferenciaEtiquetaList(tp_id, dataInicio, dataFim) {
  try {
    const response = await authHttp().get(
      routes.urlGetReconferenciaEtiquetaList(tp_id, dataInicio, dataFim),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getReconferenciaEtiquetaDetail(conferencia_id, tp_id) {
  try {
    const response = await authHttp().get(
      routes.urlGetReconferenciaEtiquetaDetail(conferencia_id, tp_id),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postReconferenciaEtiquetaCancelar(conferencia_id, user_id, canceled_reason, tp_id) {
  try {
    const response = await authHttp().post(
      routes.urlPostReconferenciaEtiquetaCancelar(conferencia_id),
      { user_id, canceled_reason, tp_id },
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getReconferenciaEtiquetaResumo(conferencia_id, tp_id) {
  try {
    const response = await authHttp().get(
      routes.urlGetReconferenciaEtiquetaResumo(conferencia_id, tp_id),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postReconferenciaEtiquetaResumoOcorrencias(
  conferencia_id,
  tipo,
  associacoes,
  tp_id,
) {
  try {
    await authHttp().post(
      routes.urlPostReconferenciaEtiquetaResumoOcorrencias(conferencia_id, tipo),
      { associacoes, tp_id },
    )
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postReconferenciaEtiquetaResumoFinalizar(conferencia_id, resumo, tp_id) {
  try {
    await authHttp().post(routes.urlPostReconferenciaEtiquetaResumoFinalizar(conferencia_id), {
      ...resumo,
      tp_id,
    })
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getAcompanhamentoItensSeparados(picking_id) {
  try {
    const response = await authHttp().get(routes.urlGetAcompanhamentoItensSeparados(picking_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getBipsFaltantes(picking_id) {
  try {
    const response = await authHttp().get(routes.urlGetBipsFaltantes(picking_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
